import { render, staticRenderFns } from "./RankingDetailsPage.vue?vue&type=template&id=323110db&scoped=true&"
import script from "./RankingDetailsPage.vue?vue&type=script&lang=js&"
export * from "./RankingDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./RankingDetailsPage.vue?vue&type=style&index=0&id=323110db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323110db",
  null
  
)

export default component.exports